import { GetColorDefinition } from 'atoms/colors/colors';

import Text from 'quarks/Text';

const colorizeText = (heading: string, color: GetColorDefinition) => {
  if (!heading) {
    return;
  }

  const colorizedArray = heading.split(/\{%|%\}/).map((segment, index) => {
    if (index % 2 === 1) {
      return (
        <Text key={segment} textColor={color || 'primary-700'} fontFamily="secondaryFont">
          {segment}
        </Text>
      );
    }

    return segment;
  });

  return colorizedArray;
};

export default colorizeText;
